<template>
    <div class="sidebar-container" v-bind:class="{ unfold: !collapsed }">
        <div style="position: fixed;">
            <div class="header">
                <menutabs :sideways="true" class="hover-gray" :state="{ tabs: tabs }" :tab-selected="tabSelected"
                    @tab-select="TabSelect"></menutabs>
            </div>
        </div>
        <div class="section">
            <div class="time-table-header vlh-pl-5">{{ $t('roster.comp.timeFrame') }}
                <div style="float: right;">
                    <i class="fas fa-plus-circle add-btn" @click="OpenCreateVlhTimeFrameModal()"></i>
                </div>
            </div>
            <table style="text-align: left;">
                <tbody>
                    <tr :key="item.id" v-for="(item, index) in orderedVlhTimeFrames"
                        :style="{ background: `var(--contrast-${index % 2})` }">
                        <td class="vlh-pl-5">{{ item.name }}</td>
                        <td>{{ item.label }}</td>
                        <td>{{ item.weekDaysLabel }}</td>
                        <td class="vlh-dark-btn"><i class="fas fa-edit" v-tooltip="$t('global.ui.edit')"
                                @click="OpenEditVlhTimeFrameModal(item.value)" /></td>
                        <td class="vlh-dark-btn"><i class="fas fa-trash" v-tooltip="$t('global.ui.delete')" style="color: darkred"
                                @click="OpenDeleteVlhTimeFrameModal(item.value)" /></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class=section>
            <div class="time-table-header vlh-pl-5">{{ $t('indicator.vlh.keyFigureDependencyOptional') }}
                <div v-if="!vlhConfigForMainType" style="float: right;">
                    <i class="fas fa-plus-circle add-btn" @click="OpenCreateVlhConfigModal()"></i>
                </div>
            </div>
            <table v-if="vlhConfigForMainType" style="text-align: left;">
                <tbody>
                    <tr style="background: var(--contrast-0)">
                        <td class="vlh-pl-5">{{ $t('roster.view.keyFigure') }}</td>
                        <td>{{ vlhConfigForMainType.name }}</td>
                        <td class="vlh-dark-btn"><i class="fas fa-edit" v-tooltip="$t('global.ui.edit')"
                                @click="OpenEditVlhConfigModal(vlhConfigForMainType.value)" /></td>
                        <td class="vlh-dark-btn"><i class="fas fa-trash" v-tooltip="$t('global.ui.delete')" style="color: darkred"
                                @click="OpenDeleteVlhConfigModal(vlhConfigForMainType.value)" /></td>
                    </tr>
                    <tr style="background: var(--contrast-1)">
                        <td class="vlh-pl-5" style="width: 40%;">{{ $t('indicator.vlh.base') }}</td>
                        <td>{{ vlhConfigForMainType.label }}</td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="section">
            <div class="time-table-header vlh-pl-5">{{ $t('indicator.vlh.unitsOptional') }}
                <div style="float: right;">
                    <i class="fas fa-plus-circle add-btn" @click="OpenCreateVlhConversionModal()"></i>
                </div>
            </div>
            <table style="text-align: left;">
                <tbody>
                    <tr :key="item.id" v-for="(item, index) in orderedVlhConversions"
                        :style="{ background: `var(--contrast-${index % 2})` }">
                        <td class="vlh-pl-5" style="width: 40%;">{{ item.name }}</td>
                        <td>{{ item.label }}</td>
                        <td class="vlh-dark-btn"><i class="fas fa-edit" v-tooltip="$t('global.ui.edit')"
                                @click="OpenEditVlhConversionModal(item.value)" /></td>
                        <td class="vlh-dark-btn"><i class="fas fa-trash" v-tooltip="$t('global.ui.delete')" style="color: darkred"
                                @click="OpenDeleteVlhConversionModal(item.value)" /></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import vClickOutside from 'v-click-outside'

Vue.use(vClickOutside)
export default {
    name: "vlhsidebar",
    data() {
        return {
            tabSelected: { view: '' },
            collapsed: true,
        }
    },
    watch: {},
    props: {
        tabs: Array,
        orderedVlhTimeFrames: Array,
        visibleTimeFrames: Set,
        OpenCreateVlhTimeFrameModal: {
            type: Function,
            required: true
        },
        OpenEditVlhTimeFrameModal: {
            type: Function,
            required: true
        },
        OpenDeleteVlhTimeFrameModal: {
            type: Function,
            required: true
        },
        vlhConfigForMainType: Object,
        OpenCreateVlhConfigModal: {
            type: Function,
            required: true
        },
        OpenEditVlhConfigModal: {
            type: Function,
            required: true
        },
        OpenDeleteVlhConfigModal: {
            type: Function,
            required: true
        },
        orderedVlhConversions: Array,
        OpenCreateVlhConversionModal: {
            type: Function,
            required: true
        },
        OpenEditVlhConversionModal: {
            type: Function,
            required: true
        },
        OpenDeleteVlhConversionModal: {
            type: Function,
            required: true
        },
    },
    mounted() {
        window.addEventListener('mousedown', this.CollapseWatch);
    },
    beforeDestroy() {
        window.removeEventListener('mousedown', this.CollapseWatch);
    },
    methods: {
        TabSelect(tab) {
            if (tab.selected && !this.collapsed) {
                this.collapsed = true;
            } else {
                this.tabs.forEach(t => t.selected = false);
                tab.selected = true;
                this.tabSelected = tab;
                this.collapsed = false;
            }
        },
        CollapseWatch($event) {
            if (!window.mouse.element.closest('.sidebar-container') && !window.mouse.element.closest('.c-dropdown') && !window.mouse.element.closest('.popup-alert')) this.collapsed = true;
        }
    }
}
</script>

<style scoped>
.sidebar-container {
    position: fixed;
    bottom: 0;
    right: -600px;
    height: calc(100% - var(--header-height) - var(--tab-menu-height) + -53px) !important;
    width: 600px;
    background: var(--bg);
    color: var(--col-label-default);
    transition: 0.2s;
    z-index: 10;
}

.sidebar-container.unfold {
    right: 0px;
    overflow-y: auto;
    border-left: 3px var(--contrast-1) solid;
}

.section {
    display: flex;
    flex-direction: column;
    padding: 10px;
}

.header {
    position: absolute;
    top: 245px;
    left: -28px;
    width: 30px;
    margin: auto;
    align-items: center;
    height: fit-content;
}

.time-table-header {
    background: var(--contrast-4);
    color: var(--bg);
    font-weight: bold;
    width: 100%;
    text-align: left;
    padding: 5px;
}

.vlh-pl-5 {
    padding-left: 5px;
}

.vlh-dark-btn {
    text-align: center;
    width: 1px;
    padding: 0 3px 0 3px;
}

.vlh-dark-btn:hover {
    background: #6d8d23;
}

.add-btn:hover {
    color: #6d8d23;
}
</style>
